export enum DeliveryOption {
  HIDE = 'true',
  SHOW = 'false',
}
